var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      class: {
        hero: true,
        mobile: _vm.isMobile(_vm.$mq),
        "is-experiment": _vm.isExperiment
      }
    },
    [
      _c("div", { staticClass: "container" }, [
        _c("header", [
          _c(
            "h1",
            { class: { "is-mathcounts": _vm.isMathcounts } },
            [_vm._t("header")],
            2
          ),
          _vm._v(" "),
          _c("h2", [_vm._t("intro-text")], 2),
          _vm._v(" "),
          _c(
            "a",
            {
              directives: [
                {
                  name: "track",
                  rawName: "v-track:click",
                  value: _vm.ctaAxParams,
                  expression: "ctaAxParams",
                  arg: "click"
                }
              ],
              staticClass: "btn",
              attrs: { href: _vm.getStartedHref },
              on: { click: _vm.getStartedClickHandler }
            },
            [_vm._v("\n        " + _vm._s(_vm.ctaButtonText) + "\n      ")]
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "video" }, [
          _c(
            "video",
            {
              attrs: {
                preload: "auto",
                autoplay: "",
                muted: "",
                playsinline: "",
                loop: ""
              },
              domProps: { muted: true }
            },
            [_c("source", { attrs: { src: _vm.videoUrl, type: "video/mp4" } })]
          )
        ])
      ]),
      _vm._v(" "),
      _vm.isExperiment
        ? [
            _vm._m(0),
            _vm._v(" "),
            _c("div", { staticClass: "why-join-brilliant" }, [
              _c("div", { staticClass: "content-wrap" }, [
                _c("h3", [
                  _vm._v("Join over 10 million people learning on Brilliant")
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "list" },
                  [
                    _c("PublishersList", {
                      staticClass: "publishers homepage-experiment",
                      attrs: { reduced: true }
                    }),
                    _vm._v(" "),
                    _c("div", { staticClass: "sep" }),
                    _vm._v(" "),
                    _c("AppRating", {
                      staticClass: "homepage-experiment",
                      attrs: { landing: true, mobile: _vm.isMobile(_vm.$mq) }
                    }),
                    _vm._v(" "),
                    _c("div", { staticClass: "sep" }),
                    _vm._v(" "),
                    _c("TrustpilotRating", {
                      staticClass: "landing homepage-experiment"
                    }),
                    _vm._v(" "),
                    _c("div", { staticClass: "sep" }),
                    _vm._v(" "),
                    _vm._m(1)
                  ],
                  1
                )
              ])
            ])
          ]
        : _c(
            "div",
            { staticClass: "social-proof container" },
            [
              _c("PublishersList", { attrs: { reduced: true } }),
              _vm._v(" "),
              _c("div", { staticClass: "sep" }),
              _vm._v(" "),
              _c("AppRating", {
                attrs: { landing: true, mobile: _vm.isMobile(_vm.$mq) }
              }),
              _vm._v(" "),
              _c("div", { staticClass: "sep" }),
              _vm._v(" "),
              _c("TrustpilotRating", { staticClass: "landing" })
            ],
            1
          )
    ],
    2
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "b-topics container" }, [
      _c("div", { staticClass: "topic" }, [
        _c("img", {
          attrs: {
            src:
              "/site_media/version-1de7ac9e60/images/homepage/topic-math.png",
            alt: "Math"
          }
        }),
        _vm._v(" "),
        _c("h3", [_vm._v("Math")])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "topic" }, [
        _c("img", {
          attrs: {
            src:
              "/site_media/version-32dd0ee41c/images/homepage/topic-data-analysis.png",
            alt: "Data Analysis"
          }
        }),
        _vm._v(" "),
        _c("h3", [_vm._v("Data Analysis")])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "topic" }, [
        _c("img", {
          attrs: {
            src:
              "/site_media/version-0a482e698b/images/homepage/topic-computer-science.png",
            alt: "Computer Science"
          }
        }),
        _vm._v(" "),
        _c("h3", [_vm._v("Computer Science")])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "topic" }, [
        _c("img", {
          attrs: {
            src:
              "/site_media/version-9cddcd3333/images/homepage/topic-programming.png",
            alt: "Programming"
          }
        }),
        _vm._v(" "),
        _c("h3", [_vm._v("Programming")])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "topic" }, [
        _c("img", {
          attrs: {
            src:
              "/site_media/version-affbf78367/images/homepage/topic-science-and-enginnering.png",
            alt: "Science & Engineering"
          }
        }),
        _vm._v(" "),
        _c("h3", [_vm._v("Science & Engineering")])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "app-awards" }, [
      _c("img", {
        attrs: {
          src:
            "/site_media/version-d8772fb6dd/images/homepage/app-of-the-day.png",
          alt: "App of the day award"
        }
      }),
      _vm._v(" "),
      _c("img", {
        attrs: {
          src: "/site_media/version-c1564146cb/images/homepage/best-app.png",
          alt: "Best-app award"
        }
      })
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }